<template>
  <div>
    <div
      v-if="parsedTimeline && parsedTimeline[0]"
      class="relative w-auto top-2"
    >

      <div
        v-for="(step, index) of parsedTimeline"
        :key=index
        class="box-border relative w-full pl-2 border-l-2 border-transparent h-20 md:h-16"
      >

        <!-- line -->
        <div
          v-if="step.line"
          :class="step.line"
        />

        <!-- circle -->
        <div :class="step.circle">

          <!-- icon success -->
          <svg
            v-if="step.icon === 'check'"
            xmlns="http://www.w3.org/2000/svg"
            :class="step.iconClass"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>

          <!-- icon error -->
          <svg
            v-if="step.icon === 'error'"
            xmlns="http://www.w3.org/2000/svg"
            :class="step.iconClass"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <div :class="step.alignClass">
          <p
            :class="step.textClass"
          >
            {{ step.text }}
          </p>
          <p
            :class="step.subTextClass"
          >
            {{ step.subText }}
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="!parsedTimeline || !parsedTimeline[0]"
      class="flex items-center justify-center w-56 h-48 text-sm font-normal text-gray-600 top-2 font-italic"
    >
      Histórico indisponível
    </div>

  </div>
</template>

<script>
import {
  PAYMENT_NOT_APPROVED,
  CANCELED
} from '@/enum/enum.cluster.status'
export default {
  name: 'CompleteTimeLine',

  props: {
    timeline: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      parsedTimeline: [],
      ERROR_STATUS: [PAYMENT_NOT_APPROVED, CANCELED]
    }
  },

  created () {
    this.init()
  },

  methods: {
    init () {
      this.parsedTimeline = this.parseTimeline(this.timeline)
    },

    parseTimeline (timelineMos) {
      if (!timelineMos || !timelineMos.statuses || !timelineMos.statuses[0]) return []

      const hasError = this.getErrorStatusFromTimeline(this.ERROR_STATUS, timelineMos.statuses)

      const parsedTimeline = this.buildParsedTimeline(hasError, timelineMos.statuses)

      return parsedTimeline
    },

    getErrorStatusFromTimeline (errorStatus, timeline) {
      let hasError = false
      for (const element of timeline) {
        hasError = element.list.some(status => errorStatus.includes(status.cluster.toUpperCase()))
        if (hasError) {
          return hasError
        }
      }

      return hasError
    },

    buildParsedTimeline (hasError, timeline) {
      const classes = {
        alignSingle: 'relative px-4 -top-2',
        alignComposted: 'relative px-4 -top-5',
        circle: {
          small: 'w-4 h-4 absolute -top-1.5 -left-2 rounded-full -ml-px flex justify-center items-center z-10',
          medium: 'w-6 h-6 absolute -top-2 -left-3 rounded-full flex justify-center items-centerz-10',
          big: 'w-9 h-9 absolute -top-3 -left-4 -ml-0.5 rounded-full flex justify-center items-center z-10'
        },
        line: 'absolute h-full -top-20 md:-top-16 -left-0.5',
        text: 'text-lg font-normal line-clamp-3',
        subText: 'text-sm font-normal text-gray-800 line-clamp-2'
      }

      const statuses = []
      timeline.forEach((step, index) => {
        const dateTimeChunks = new Date(step.list[0].event_date).toLocaleString('pt-BR', { hour12: false }).split(' ')
        const timeChunks = dateTimeChunks[1].split(':')
        timeChunks.splice(timeChunks.length - 1, 1)
        const date = dateTimeChunks[0]
        const time = timeChunks.join(':')
        const lineType = index > 0 ? classes.line : null

        statuses.push({
          text: step.resumido,
          subText: step.list[0].substatus ? '' : `${date} às ${time}`,
          subTextClass: classes.subText,
          circle: hasError ? `${classes.circle.big} bg-red-mobly` : `${classes.circle.big} bg-green-mobly`,
          line: lineType ? `${lineType} border-l-2  ${hasError ? 'border-red-mobly' : 'border-green-mobly'}` : null,
          textClass: hasError ? `${classes.text} text-red-mobly` : `${classes.text} text-green-mobly`,
          icon: hasError ? 'error' : 'check',
          iconClass: 'w-5 h-5 text-white',
          date: step.list[0].event_date,
          alignClass: step.list[0].substatus ? classes.alignSingle : classes.alignComposted
        })

        for (const subStep of step.list) {
          const subDateTimeChunks = new Date(subStep.event_date).toLocaleString('pt-BR', { hour12: false }).split(' ')
          const subTimeChunks = subDateTimeChunks[1].split(':')
          subTimeChunks.splice(subTimeChunks.length - 1, 1)
          const subDate = subDateTimeChunks[0]
          const subTime = subTimeChunks.join(':')

          if (subStep.substatus) {
            statuses.push({
              text: `${subDate} às ${subTime}`,
              subText: subStep.substatus || null,
              textClass: classes.subText,
              subTextClass: classes.subText,
              circle: hasError ? `${classes.circle.small} bg-red-mobly` : `${classes.circle.small} bg-green-mobly`,
              line: hasError ? `${classes.line} border-l-2 border-red-mobly` : `${classes.line} border-l-2 border-green-mobly`,
              icon: hasError ? 'error' : 'check',
              iconClass: 'w-3 h-3 text-white',
              date: subStep.event_date,
              alignClass: classes.alignComposted
            })
          }
        }
      })

      return statuses
    }
  }
}
</script>
